import * as React from "react"
import { useCallback, useState } from "react"
import { useComputed } from "@preact/signals-react"
import { Box, Grid, IconButton, Chip } from "@mui/material"
import { TextFieldSeeker } from "@ui-seeker/core"
import PlayArrowIcon from "@mui/icons-material/PlayArrow"

import { BACKEND_APIS } from "@constants"
import { postSubmit } from "@ui-seeker/utils"
import { formData } from "../../@signals"


export default function AdminBrandsKeywordTester({ disabled }) {
    const [candidate, setCandidate] = useState("")
    const [result, setResult] = useState(null)
    const [loading, setLoading] = useState(false)

    const hasKeywords = useComputed(() => !!formData.value?.keyword)

    const handleTest = useCallback(() => {
        if (!candidate || !formData.value?.keyword) return

        setLoading(true)
        setResult(null)

        postSubmit(`${BACKEND_APIS.BRANDS}/crud/test-keywords`, {
            keyword: formData.value.keyword,
            excludedWord: formData.value.excludedWord || "",
            wholeWord: formData.value.wholeWord || false,
            candidate
        }).then(res => {
            setResult(res.match)
        }).catch(() => {
            setResult(null)
        }).finally(() => {
            setLoading(false)
        })
    }, [candidate])

    if (!hasKeywords.value) return null

    return <Grid container spacing={1} alignItems="center">
        <Grid item xs>
            <TextFieldSeeker
                label="Test keywords"
                placeholder="Enter a product name to test..."
                value={candidate}
                disabled={disabled || loading}
                onChange={e => {
                    setCandidate(e.target.value)
                    setResult(null)
                }}
                onKeyDown={e => e.key === "Enter" && handleTest()}
            />
        </Grid>

        <Grid item>
            <IconButton
                onClick={handleTest}
                disabled={disabled || loading || !candidate}
                color="primary"
                size="small"
            >
                <PlayArrowIcon />
            </IconButton>
        </Grid>

        {result !== null && <Grid item>
            <Chip
                label={result ? "Match" : "No match"}
                color={result ? "success" : "error"}
                size="small"
                variant="outlined"
            />
        </Grid>}
    </Grid>
}
